import { createI18n } from '@calendly/i18n'
import moment from 'moment-timezone'

const momentLocales = {
  de: () => import(/* webpackChunkName: "moment/locale/de" */'moment/locale/de'),
  en: () => Promise.resolve({}), // en locale is baked into moment itself
  es: () => import(/* webpackChunkName: "moment/locale/es" */'moment/locale/es'),
  fr: () => import(/* webpackChunkName: "moment/locale/fr" */'moment/locale/fr'),
  it: () => import(/* webpackChunkName: "moment/locale/it" */'moment/locale/it'),
  nl: () => import(/* webpackChunkName: "moment/locale/nl" */'moment/locale/nl'),
  pt: () => import(/* webpackChunkName: "moment/locale/pt" */'moment/locale/pt'),
  uk: () => import(/* webpackChunkName: "moment/locale/uk" */'moment/locale/uk'),
}

export const { i18n, useI18n } = createI18n({
  de: () => import('./de.locale.js'),
  en: () => import('./en.locale.js'),
  es: () => import('./es.locale.js'),
  fr: () => import('./fr.locale.js'),
  it: () => import('./it.locale.js'),
  nl: () => import('./nl.locale.js'),
  pt: () => import('./pt.locale.js'),
  uk: () => import('./uk.locale.js')
})

export const withI18n = (Component) => (props) => {
  const { i18n: i18nProp } = useI18n()

  return <Component {...props} i18n={i18nProp} />
}

i18n.onCurrentLocaleChange(() => moment.locale(i18n.locale))
i18n.onLocaleRequested(async (locale) => {
  await momentLocales[locale]()
  // loading an additional moment locale makes it current
  // so we have to switch back to the current main locale
  moment.locale(i18n.locale)

  if (locale === 'uk') {
    moment.updateLocale('uk', {
      meridiem: undefined
    })
  }
})
